export default "/_next/static/images/flags-f8e36afc33abef61153081fe19a12bb7.png";